import { useQuery } from "@tanstack/react-query";

type BrregEnhet = {
  organisasjonsnummer: string;
  navn: string;
};

type BrregSearchResponse = {
  _embedded?: {
    enheter: BrregEnhet[];
  };
};

export const useBrregSearch = (query: string) => {
  return useQuery<BrregSearchResponse, unknown, BrregEnhet[]>({
    queryKey: ["brregSearch", query],
    queryFn: async () => {
      const data = await fetch(
        `https://data.brreg.no/enhetsregisteret/api/enheter?navn=${encodeURIComponent(query)}&size=5`,
      );
      return await data.json();
    },
    enabled: query.length >= 2,
    staleTime: 60000,
    select: (data) => data?._embedded?.enheter ?? [],
  });
};
